import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserInfo {
  role: {
    name: string;
  };
}

interface OrganizationConfig {
  organization: {
    name: string;
  };
}

interface AdminNewDesignState {
  isAdminLoginNewDesign: boolean;
}

const initialState: AdminNewDesignState = {
  isAdminLoginNewDesign: false,
};

const isAdminNewDesignSlice = createSlice({
  name: 'isAdminNewDesign',
  initialState,
  reducers: {
    setIsAdminLoginNewDesign: (state, action: PayloadAction<{ userInfo: UserInfo }>) => {
      const { userInfo } = action.payload;
      state.isAdminLoginNewDesign =
        userInfo.role.name === UserRoleName.Admin ||
        userInfo.role.name === UserRoleName.SuperAdmin ||
        userInfo.role.name === UserRoleName.OrganizationAdmin ||
        userInfo.role.name === UserRoleName.CareAdvisor ||
        userInfo.role.name === UserRoleName.Provider;
    },
    resetIsAdminLoginNewDesign: (state) => {
      state.isAdminLoginNewDesign = false;
    },
  },
});

export const { setIsAdminLoginNewDesign, resetIsAdminLoginNewDesign } = isAdminNewDesignSlice.actions;

export default isAdminNewDesignSlice.reducer;
